import * as tf from '@tensorflow/tfjs-core';

import { TAny } from 'types';

const resetBackend = async (backendName: TAny) => {
  const ENGINE = tf.engine();
  if (!(backendName in ENGINE.registryFactory)) {
    throw new Error(`${backendName} backend is not registed.`);
  }

  if (backendName in ENGINE.registry) {
    const backendFactory = tf.findBackendFactory(backendName);
    tf.removeBackend(backendName);
    tf.registerBackend(backendName, backendFactory);
  }

  await tf.setBackend(backendName);
};

export const setBackendAndEnvFlags = async (
  flagConfig: TAny,
  backend: TAny
) => {
  if (flagConfig === null) {
    return;
  } else if (typeof flagConfig !== 'object') {
    throw new Error(
      `An object is expected, while a(n) ${typeof flagConfig} is found.`
    );
  }

  tf.env().setFlags(flagConfig);

  const [runtime, $backend] = backend.split('-');

  if (runtime === 'tfjs') {
    await resetBackend($backend);
  }
};

const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
};

const isiOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const isMobile = () => {
  return isAndroid() || isiOS();
};

export const isSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
